
import groq from 'groq';
import { formWithReferences } from '@pkg/sanity-utils/formWithReferences'

/**
 * When loading this Block in a modular content block, the following fields will be loaded.
 * Ensure all fields used in your block are loaded below.
 * _type and _key will always be included, and do not need to be specified below.
 *
 * The fields are loaded like so:
 *   _type == "YOUR_BLOCK" => {
 *     _type,
 *     _key,
 *     YOUR_FIELDS...,
 *   }
 */
export const blockFormsFields = groq`
  ...,
  form->{
    ${formWithReferences}
  },
`;